import React from 'react';

/**
 * A small amber "!" badge pinned to the top-right corner of an operation button
 * (Repair/R&R/Paint) to flag that the operation is active but resolves to $0 or
 * 0 hours — usually an unmatched line that carries no insurer allowance, so it
 * would go into the quote silently blank.
 *
 * The parent button must be positioned (relative) for the absolute corner to anchor.
 */
const ZeroValueBadge = ({ title = 'No hours or cost set — this line will be blank on the quote' }) => (
  <span
    className="absolute -top-1.5 -right-1.5 z-10 flex h-4 w-4 items-center justify-center rounded-full bg-amber-500 text-[10px] font-bold leading-none text-white ring-2 ring-background"
    title={title}
    aria-label={title}
    role="img"
  >
    !
  </span>
);

export default ZeroValueBadge;
